var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-video)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.1183 0H14.1267L20.91 7.09345V20.8744C20.91 22.5996 19.5128 24 17.7917 24H6.1183C4.39716 24 3 22.5996 3 20.8744V3.12558C3 1.40042 4.39716 0 6.1183 0Z",
    fill: "#FA0000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1165 0V7.03256H20.9099L14.1165 0Z",
    fill: "white",
    fillOpacity: 0.301961
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1009 12.8481C16.02 12.7872 15.8985 12.7872 15.8073 12.8278L13.7926 13.8426V13.1119C13.7926 12.5944 13.3876 12.1885 12.8713 12.1885H8.57854C8.07233 12.1885 7.65723 12.5944 7.65723 13.1119V16.7957C7.65723 17.3132 8.07233 17.7191 8.57854 17.7191H12.8713C13.3876 17.7191 13.7926 17.3132 13.7926 16.7957V16.065L15.8073 17.0798C15.9592 17.1508 16.1414 17.09 16.2224 16.9377C16.2427 16.8971 16.2528 16.8464 16.2528 16.7957V13.1119C16.2528 13.0003 16.1921 12.8988 16.1009 12.8481ZM10.7249 16.1868C10.0466 16.1868 9.49986 15.6286 9.49986 14.9487C9.49986 14.2688 10.0466 13.7208 10.7249 13.7208C11.4032 13.7208 11.95 14.2688 11.95 14.9487C11.95 15.6286 11.4032 16.1868 10.7249 16.1868Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-video"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.ed64a5abfbf506cb1a86a5e5d3b7e38a.svg";
export { ForwardRef as ReactComponent };